import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import mixins from '@/store/enums/initEnums'
import tableMixin from '@/@core/mixins/table'
import allEnums from '@/store/enums/allEnums'
import ZLanguage from '@/tools/language.vue'
import ZPagination from '@/tools/pagination.vue'
import { moment } from '@/modules/moment'
import filter from '@/modules/filter'
// import permission from '@/modules/permission'

import '@/libs/acl'
// Global Components
import './global-components'
import vSelect from 'vue-select'

import 'boxicons'
// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'
import '@/libs/clipboard'

// must used components
import {
  BTable,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BPagination,
  BFormInput,
  BCard,
  BCardBody,
  BLink,
  BButton,
  BSpinner,
  BAvatar,
  BForm,
  BOverlay,
  BInputGroup,
  BInputGroupPrepend,
  BTab,
  BTabs,
  BFormCheckbox,
  BMedia,
  BFormTextarea,
  BFormTags,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BImg,
  BDropdown,
  BDropdownItem,
  BDropdownForm,
  BDropdownDivider,
  BProgress,
  BCardText,
  BCardTitle,
  BTooltip,
  BFormRadio,
  BFormRadioGroup,
  VBTooltip,
} from 'bootstrap-vue'

import Cleave from 'vue-cleave-component'

import Ripple from 'vue-ripple-directive'
import firebase from 'firebase/app'
import App from './App.vue'
import store from './store'
import router from './router'
// Firebase App (the core Firebase SDK) is always required and must be listed first
// If you are using v7 or any earlier version of the JS SDK, you should import firebase using namespace import
// import * as firebase from "firebase/app"

import 'firebase/analytics'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import trash from '@/tools/trash.vue'
Vue.component('date-picker', VuePersianDatetimePicker)
Vue.use(VuePersianDatetimePicker, {
  name: 'custom-date-picker',
  props: {
    inputFormat: 'YYYY-MM-DD HH:mm',
    editable: false,
    inputClass: 'form-control my-custom-class-name',
    placeholder: '',
    altFormat: 'YYYY-MM-DD HH:mm',
    color: '#7367f0',
    autoSubmit: false,
    format: 'YYYY-MM-DD',
    displayFormat: 'jYYYY/jMM/jDD',
  },
})
Vue.component('BTable', BTable)
Vue.component('BBadge', BBadge)
Vue.component('BRow', BRow)
Vue.component('BCol', BCol)
Vue.component('BFormGroup', BFormGroup)
Vue.component('BPagination', BPagination)
Vue.component('BFormInput', BFormInput)
Vue.component('BCard', BCard)
Vue.component('BCardBody', BCardBody)
Vue.component('BLink', BLink)
Vue.component('BButton', BButton)
Vue.component('BSpinner', BSpinner)
Vue.component('BAvatar', BAvatar)
Vue.component('BForm', BForm)
Vue.component('BOverlay', BOverlay)
Vue.component('BInputGroup', BInputGroup)
Vue.component('BInputGroupPrepend', BInputGroupPrepend)
Vue.component('BTab', BTab)
Vue.component('BTabs', BTabs)
Vue.component('BFormCheckbox', BFormCheckbox)
Vue.component('vSelect', vSelect)
Vue.component('Cleave', Cleave)
Vue.component('BMedia', BMedia)
Vue.component('BFormTextarea', BFormTextarea)
Vue.component('BFormTags', BFormTags)
Vue.component('BMediaAside', BMediaAside)
Vue.component('BMediaBody', BMediaBody)
Vue.component('BFormFile', BFormFile)
Vue.component('BImg', BImg)
Vue.component('BDropdown', BDropdown)
Vue.component('BDropdownItem', BDropdownItem)
Vue.component('BDropdownForm', BDropdownForm)
Vue.component('BDropdownDivider', BDropdownDivider)
Vue.component('BProgress', BProgress)
Vue.component('BCardText', BCardText)
Vue.component('BCardTitle', BCardTitle)
Vue.component('BTooltip', BTooltip)
Vue.component('BFormRadio', BFormRadio)
Vue.component('BFormRadioGroup', BFormRadioGroup)
Vue.component('trash', trash)
Vue.directive('Ripple', Ripple)
Vue.directive('b-tooltip', VBTooltip)

Vue.filter('price', filter.price)
Vue.filter('date', filter.date)
Vue.filter('time', filter.time)
Vue.filter('duration', filter.duration)
Vue.filter('dateToTime', filter.dateToTime)
Vue.filter('fromNow', filter.fromNow)
Vue.filter('filterToCurrency', filter.filterToCurrency)

Vue.prototype.$moment = moment
Vue.prototype.$duration = moment.duration
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false



Vue.component('ZLanguage', ZLanguage)
Vue.component('ZPagination', ZPagination)

const app = new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')

app.$store.commit('enums/setItems', allEnums)

Vue.mixin(mixins)
Vue.mixin(tableMixin)
